import Vue from 'vue'
import state from '@/lib/appState'
import cart from '@/lib/cart'
import { trigger } from '@/lib/utils'

Vue.component('add-to-bag-button', {
  props: [],
  data () {
    const product = window.BARREL.product
    return {
      state,
      product,
      quantity: 1,
      isProcessing: false
    }
  },
  watch: {
    'state.selectedOptions': {
      handler () {
        this.pickActiveVariant()
      },
      deep: true
    },
    deep: true
  },
  computed: {
    activeVariant () {
      return this.state.activeVariant
    }
  },
  methods: {
    pickActiveVariant () {
      const {
        variants = [],
        options = []
      } = this.product

      for (let i = 0; i < variants.length; i++) {
        let variant = variants[i]
        const isMatch = options.every((option, _i) => {
          return (
            variant[`option${_i + 1}`] === state.selectedOptions[option]
          )
        })
        if (isMatch) {
          state.activeVariant = variant
          break
        } else {
          state.activeVariant = {}
        }
      }
    },
    async addToCart () {
      this.isProcessing = true
      const options = {
        id: this.activeVariant.id,
        quantity: this.quantity,
      }

      cart.add([options]).then((code) => {
        if (code.status === 422) {
          this.error = code.description
          return
        }
        cart.get().then((data) => {
          state.cart = data
          trigger('mini-cart-open', document.body, data)
          this.isProcessing = false
          trigger('update-gwp', document.body)
        })
      })
    },
  }
})